!(function($){
	$(document).ready(function() {
		if (window.mapsherpa) {
			if (mapsherpa.initialized) {
				setupMapsherpa();
			} else {
				mapsherpa.once('initialized', setupMapsherpa);
			}

			function setupMapsherpa() {
				$('body').on('click', 'a[data-printpdf-id]', function() {
      	  var id = $(this).attr('data-printpdf-id');
        	mapsherpa.preview(id);
      	});
			}
		}
	});
})(jQuery);